module.exports = __webpack_public_path__ + "img/bg_function04_3_t.7856ce49.png";